export default {
      id: "close-filter-usage",
      viewBox: "0 0 20 21",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#close-filter",
      toString: function () {
        return this.url;
      }
    }